<template>
  <span>
    <i class="fa fa-check green" v-if="pbn.status === 'built'" title="Built" v-tooltip="'Built'"></i>
    <i class="fas fa-hammer green" v-if="pbn.status === 'building'" title="Building" v-tooltip="'Building'"></i>
    <i class="fa fa-clock orange" v-if="pbn.status === 'not-built'" title="Not Built" v-tooltip="'Not Built'"></i>
    <i class="fas fa-skull-crossbones red"
       v-tooltip="pbn.qa.status.check && pbn.qa.status.check.errors ? pbn.qa.status.check.errors.join(',') : 'Status check failing'"
       v-if="pbn.qa && pbn.qa.status && pbn.qa.status.success === false"></i>
    <i class="fas fa-key green" v-tooltip="'SSO'" v-if="pbn.sso"></i>
    <router-link :to="{path: '/pbn/' + pbn.punyDomain }">{{ pbn.domain }}</router-link>
    <a :href="'https://' + pbn.domain" target="_blank"><i class="fa fa-external-link"></i></a>
    <a :href="'https://app.ahrefs.com/site-explorer/overview/v2/subdomains/live?target=' + pbn.domain" target="_blank"><i class="fab fa-angular"></i></a>
    <i class="fas fa-parking text-navy" title="Parked" v-if="pbn.parked"></i>
  </span>
</template>
<script>
export default {
  props: ['pbn']
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/PbnListItem.vue